






























































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';
import _ from 'lodash';
import { v4 as uuidv4 } from 'uuid';
import showFilesModal from '../components/showFiles.vue';
import SubtitleCatalogs from '../components/SubtitleCatalogs.vue';

import { Spinner } from 'vue-image-spinner2';
import { Debounce } from 'vue-debounce-decorator';
import { asyncForEach } from '@/utils';
import Pica from 'pica';

@Component({
    name: 'catalog-detail-modal',
    components: {
        showFilesModal,
        SubtitleCatalogs,
        Spinner,
    },
    computed: {
        ...mapState('catalogs', ['activeCatalogLoading', 'activeCatalog']),
        ...mapState('auth', ['currentUser']),
        ...mapState('products', ['cacheProducts', 'cacheProductsLoading']),
    },
})
export default class CatalogDetailModal extends Vue {
    private activeCatalog!: any;
    public file_type: any = '';
    private currentUser!: any;

    canSee(roles: any) {
        return _.intersection(roles, [this.currentUser.role.name]).length > 0;
    }

    onSaveCatalog() {
        this.$store.dispatch('catalogs/postOne', {
            catalog: { data: this.activeCatalog, vm: this },
        });
    }

    onDeleteCatalog() {
        this.$store.dispatch('catalogs/deleteOne', { id: this.activeCatalog.id, vm: this });
        setTimeout(() => {
            this.$store.dispatch('catalogs/getAll');
            this.$bvModal.hide('catalog-detail-modal');
        });
    }

    async onFileChange(e: any) {
        switch (this.file_type) {
            case 'image':
                if (e.target) {
                    const files = e.target.files;
                    // files.forEach((file: any) => {
                    await asyncForEach(files, async (file: any) => {
                        if (!file) return;
                        try {
                            this.activeCatalog.image.push(this.formatFile(file, '', ''));
                            // w - 1800
                            // h - 800
                            let dinamic_width = 1200;
                            let dinamic_height = 400;
                            // convert original file to webp
                            const resizedFile: any = await this.resizeImage(file, 0, 0);
                            this.activeCatalog.complete_gallery.push(this.formatFile(resizedFile, 0, 0));
                            const resizedFiles: any = await this.resizeImage(file, dinamic_width, dinamic_height);
                            this.activeCatalog.complete_gallery.push(this.formatFile(resizedFiles, dinamic_width, dinamic_height));
                        } catch (error) {
                            console.error('Error resizing image:', error);
                        }
                        console.log(this.activeCatalog.complete_gallery);
                        // let formData = new FormData();
                        // formData.append('image', file, file.name);
                        // this.activeCatalog.image = [
                        //     ...this.activeCatalog.image,
                        //     {
                        //         id: uuidv4(),
                        //         sort: null,
                        //         url: URL.createObjectURL(file),
                        //         origin: 'upload',
                        //         file: formData,
                        //         name: file.name,
                        //     },
                        // ];
                    });
                } else {
                    this.activeCatalog.image = [
                        ...this.activeCatalog.image,
                        {
                            id: e.id,
                            sort: null,
                            url: `https://directus.prodelec.app/assets/${e.id}`,
                            origin: 'directus-update',
                            file: null,
                        },
                    ];
                }
            default:
                console.log('Img progress...');
                break;
        }
    }

    resizeImage(file: any, width: any, height: any) {
        return new Promise((resolve, reject) => {
            const pica = new Pica();
            const img = new Image();
            img.onload = async () => {
                try {
                    if (img.width >= 1800 && img.height >= 600) {
                        const resizedCanvas = document.createElement('canvas');
                        width == 0 ? (resizedCanvas.width = img.width) : (resizedCanvas.width = width);
                        height == 0 ? (resizedCanvas.height = img.height) : (resizedCanvas.height = height);
                        const resizeOptions = {
                            filter: 'mks2013',
                        };
                        // console.log('Dimensiones originales width: ', img.width, ' height: ', img.height);
                        // console.log('Dimensiones actualizadas width: ', resizedCanvas.width, ' height: ', resizedCanvas.height);
                        await pica.resize(img, resizedCanvas, resizeOptions);
                        // const resizedDataURL = resizedCanvas.toDataURL('image/jpeg');
                        resizedCanvas.toBlob((blob) => {
                            const resizedFile = new File([blob], file.name, { type: 'image/webp' });
                            // const resizedFile = new File([blob], file.name, { type: 'image/jpeg' });
                            resolve(resizedFile);
                        }, 'image/webp');
                        // }, 'image/jpeg');
                    } else {
                        this.activeCatalog.image.pop();
                        this.$bvToast.toast('Lo sentimos, la imagen no cumple con las dimensiones mínimas (1500x1500)', {
                            title: `Imagen no válida`,
                            variant: 'warning',
                            toaster: 'b-toaster-top-center',
                            autoHideDelay: 5000,
                        });
                        return false;
                    }
                } catch (error) {
                    reject(error);
                }
            };
            img.src = URL.createObjectURL(file);
        });
    }

    formatFile(resizedFile: any, width: any, height: any) {
        let file_name = resizedFile.name.split('.')[0];
        file_name = file_name + '_' + width + 'x' + height;
        let formData = new FormData();
        formData.append('title', file_name);
        formData.append('image', resizedFile, resizedFile.name);
        return {
            id: uuidv4(),
            sort: null,
            url: URL.createObjectURL(resizedFile),
            origin: width && width > 0 ? 'resize' : 'upload',
            file: formData,
            name: file_name,
        };
    }

    onAddSubtitle(parent: any) {
        parent.subtitle.push({
            new: true,
        });
    }

    onRemoveImg(index: any) {
        let title = this.activeCatalog.image[index].name;
        title = title.split('_')[0];
        _.remove(this.activeCatalog.complete_gallery, function (file: any) {
            return file.name.includes(title);
        });
        this.activeCatalog.image.splice(index, 1);
    }

    onOpenFilesModal(file_type: string) {
        this.file_type = file_type;
        setTimeout(() => {
            this.$bvModal.show('show-files-modal');
        }, 400);
    }

    setFileType(file_type: string) {
        this.file_type = file_type;
    }
}
